<button [matMenuTriggerFor]="root.menu">
    <span>{{ displayName }}</span>
    <mat-icon>arrow_drop_down</mat-icon>
  </button>
  <nested-menu #root [items]="items" [selectedItem]="selectedItem" (selected)="selected.emit($event)" />